module.exports = __webpack_public_path__ + "static/img/pw.12e2b9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/pw.jpg
// module id = lpSY
// module chunks = 153